
export function initializeDonateForm() {
  const formDonate = document.querySelectorAll('.webform-donate-form');
  if (formDonate.length > 0) {
    const radioButtons = document.querySelectorAll('input[name="amount_options"]');
    const customAmountInput = document.querySelector('input[name="custom_amount"]');
    const hiddenAmountField = document.querySelector('input[name="amount"]');

    function initializeHiddenField() {
      let selectedRadio = document.querySelector('input[name="amount_options"]:checked');
      if (selectedRadio) {
        hiddenAmountField.value = selectedRadio.value;
      } else if (customAmountInput.value) {
        hiddenAmountField.value = customAmountInput.value;
      }
    }

    // Initialisierung beim Laden der Seite
    initializeHiddenField();

    // Event-Listener für die Radio-Buttons
    radioButtons.forEach(function (radio) {
      radio.addEventListener('change', function () {
        hiddenAmountField.value = this.value;
        customAmountInput.value = '';  // Custom-Input leeren
      });
    });

    // Event-Listener für das Custom-Amount-Input
    customAmountInput.addEventListener('input', function () {
      const customValue = parseFloat(this.value);
      if (!isNaN(customValue) && customValue > 0) {
        hiddenAmountField.value = customValue;
        radioButtons.forEach(radio => radio.checked = false);  // Radio-Buttons deaktivieren
      }
    });

    const inputs = document.querySelectorAll('input.placeholder');

    inputs.forEach(function (input) {
      const wrapper = input.closest('.form-item');

      // Funktion, um Klasse 'noEmpty' hinzuzufügen oder zu entfernen
      function toggleNoEmptyClass() {
        if (input.value.trim() !== '' || document.activeElement === input) {
          wrapper.classList.add('noEmpty');
        } else {
          wrapper.classList.remove('noEmpty');
        }
      }

      // Event-Listener für Input-Events und Focus
      input.addEventListener('input', toggleNoEmptyClass);
      input.addEventListener('focus', toggleNoEmptyClass);
      input.addEventListener('blur', toggleNoEmptyClass);

      // Initiale Überprüfung beim Laden der Seite
      toggleNoEmptyClass();
    });
  }
}
